import { useMemo } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/customTable';

const columnsConfig = {
  year: {
    columnName: 'Year',
  },
  medianDisplayAverageSalary: {
    columnName: 'Avg. Salary',
    customSortByField: 'averageSalary',
  },
  medianDisplayHourlyRate: {
    columnName: 'Hourly Rate',
    customSortByField: 'hourlyRate',
  },
  change: {
    columnName: '% Change',
  },
};

export function SalaryByTime({ tableSet, customColumnConfig, title }) {
  const data = useMemo(() => {
    if (Array.isArray(tableSet) && tableSet.length) {
      let d = [];
      if (tableSet.length === 1) return tableSet;
      for (let i = 0; i < tableSet.length; i++) {
        if (i === tableSet.length - 1) {
          d.push({ ...tableSet[i], change: '-' });
        } else {
          let r = { ...tableSet[i] };
          const c = 100 - (tableSet[i + 1]['averageSalary'] * 100) / tableSet[i]['averageSalary'];
          r.change = (c > 0 ? '+' : '') + (c ?? 0).toFixed(1) + '%';
          d.push(r);
        }
      }
      return d;
    } else return [];
  }, [tableSet]);
  return (
    <div className="w-730 mt-48">
      <Table
        columnConfig={customColumnConfig || columnsConfig}
        columnWidthBalanced={false}
        bodyData={data}
        scrollOnMobile
        tableHeaderTitleContent={
          title ? <h3 className="zp-title-h3 text-capitalize z-mb-24">{title}</h3> : null
        }
      />
    </div>
  );
}

SalaryByTime.propTypes = {
  tableSet: PropTypes.array.isRequired,
  customColumnConfig: PropTypes.object,
};

SalaryByTime.defaultProps = {
  customColumnConfig: undefined,
};
